/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import PackageWizard from 'ui/components/PackageWizard.vue';

/**
 * This component is used to show a button to install or update a package.
 *
 * @example
 * PackageButton(:module="module" :eventId="eventId" :orgId="orgId")
 *
 * @vue-prop {Object} module the package details
 * @vue-prop {String} eventId the ID of the event
 * @vue-prop {String} orgId the ID of the organization
 * @vue-prop {'single'|'marketplace'|'libs'|'critical'|'all'} type=single the type of update (default single)
 * @vue-prop {String} [classes='']
 * @vue-prop {String} [context='']
 * @vue-prop {Boolean} [showUpdateVersion=false] whether to show the version on the button label or not
 *
 * @category ui.components
 * @exports PackageButton
 * @component
 */
const __vue_script__ = {
    name: 'PackageButton',

    components: { PackageWizard },

    props: {
        module: {
            type: Object,
            default: null
        },
        eventId: {
            type: String,
            required: true
        },
        orgId: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'single'
        },
        classes: {
            type: String,
            default: ''
        },
        context: {
            type: String,
            default: ''
        },
        showUpdateVersion: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            action: 'install',
            userCanInstall: false,
            installed: false,
            showInstallButton: false,
            showUpdateButton: false,
            showUpdateAllButton: false,
            showCriticalUpdateButton: false,
            showSignUpButton: false,
            showContactUsButton: false,
            contactUsUrl: '',
            tooltip: undefined,
            updated: false,
            showSignUpText: this.context === 'details-page',
            pkg: {}
        };
    },

    watch: {
        module() {
            this.init();
        }
    },

    created() {
        this.init();
    },

    methods: {
        /**
         * Initialize the buttons
         */
        init() {
            if (this.module) {
                this.pkg = this.module;
            } else {
                // If no module have been provided then we are going to update all packages
                this.action = 'update_all';
            }

            if (this.pkg.update || this.type === 'critical') {
                this.action = 'update';
            }

            this.installed = this.pkg.installed;
            this.userCanInstall = this.$services.user.hasPermission('pkg_repo_realms.manage_event_packages', { event_id: this.eventId });

            const userCanInstallBetaPkg = this.$services.user.hasPermission('pkg_repo_realms.install_beta_package');
            const canForceInstallPaidPkg = this.$services.user.hasPermission('pkg_repo_realms.force_install_paid_package');

            if (this.pkg.stage === 'beta' && !userCanInstallBetaPkg) {
                this.action = 'sign_up';
            }

            if (this.userCanInstall) {
                if (this.type !== 'critical') {
                    this.showInstallButton = this.action === 'install' && !this.pkg.deprecated && (this.installed || this.pkg.purchased || canForceInstallPaidPkg);
                    this.showUpdateButton = this.action === 'update' && !this.updated;
                    this.showUpdateAllButton = this.action === 'update_all';
                    this.showSignUpButton = this.action === 'sign_up' && this.pkg.stage_url;
                } else {
                    this.showCriticalUpdateButton = true;
                }
            }

            if (this.userCanInstall && this.installed && !this.pkg.update) {
                this.tooltip = {
                    content: this.$i18n.t('marketplace.package.already_installed'),
                    placement: 'bottom',
                    delay: { show: 500, hide: 100 }
                };
            }

            this.showContactUsButton = !this.installed && !this.pkg.purchased && !this.pkg.deprecated && !canForceInstallPaidPkg;
            this.contactUsUrl = this.$const.CONTACT_SALES_URL.replace('{{pkgName}}', this.pkg.name);
        },

        /**
         * Main button entry point.
         * Shows the install or update wizard modal.
         */
        async prompt() {
            this.$modal.show(PackageWizard, {
                module: this.module,
                eventId: this.eventId,
                orgId: this.orgId,
                classes: this.classes,
                context: this.context,
                type: this.type
            }, {
                height: 'auto',
                clickToClose: false
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.tooltip,
          expression: "tooltip",
        },
      ],
      staticClass: "package-button",
    },
    [
      _vm.showInstallButton
        ? _c(
            "button",
            {
              staticClass: "btn secondary",
              class: [
                _vm.installed ? "disabled" : "",
                _vm.classes,
                _vm.userCanInstall ? "" : "no-action",
              ],
              attrs: { disabled: _vm.installed },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.prompt()
                },
              },
            },
            [
              !_vm.installed
                ? _c("i", { staticClass: "ic-download" })
                : _vm._e(),
              _vm._v(
                _vm._s(
                  _vm.$t(
                    _vm.installed
                      ? "marketplace.package.installed"
                      : "marketplace.package.install"
                  )
                )
              ),
            ]
          )
        : _vm._e(),
      _vm.showUpdateButton
        ? _c(
            "button",
            {
              staticClass: "btn primary",
              class: _vm.classes,
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.prompt()
                },
              },
            },
            [
              _c("i", { staticClass: "ic-download-cloud" }),
              _vm.showUpdateVersion
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("marketplace.package.update_to", [
                          _vm.module.latest,
                        ])
                      )
                    ),
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.$t("marketplace.package.update"))),
                  ]),
            ]
          )
        : _vm._e(),
      _vm.showUpdateAllButton
        ? _c(
            "button",
            {
              staticClass: "btn primary",
              on: {
                click: function ($event) {
                  return _vm.prompt()
                },
              },
            },
            [
              _c("i", { staticClass: "ic-download-cloud" }),
              _vm._v(_vm._s(_vm.$t("marketplace.package.update_all"))),
            ]
          )
        : _vm._e(),
      _vm.showCriticalUpdateButton
        ? _c(
            "button",
            {
              staticClass: "btn urgent",
              class: _vm.classes,
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.prompt()
                },
              },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("marketplace.package.critical"))),
              ]),
            ]
          )
        : _vm._e(),
      _vm.showContactUsButton
        ? _c(
            "a",
            {
              staticClass: "btn primary",
              class: _vm.classes,
              attrs: { href: _vm.contactUsUrl, target: "_blank" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("marketplace.package.contact_us"))),
              ]),
            ]
          )
        : _vm._e(),
      _vm.showSignUpButton
        ? _c(
            "a",
            {
              staticClass: "btn secondary",
              class: _vm.classes,
              attrs: { href: _vm.pkg.stage_url, target: "_blank" },
            },
            [
              _vm.showSignUpText
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("marketplace.package.beta_sign_up"))),
                  ])
                : _vm._e(),
              !_vm.showSignUpText
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("marketplace.package.beta"))),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/PackageButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__